// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { MedicalCardFinderInputRequest } from './medicalCardFinderInputRequest.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalCardFinderRequestModel {
    'inputModel': MedicalCardFinderInputRequest | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalCardFinderRequestModel>> = [
        {
            "name":     "inputModel",
            "baseName": "inputModel",
            "type":     "MedicalCardFinderInputRequest"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalCardFinderRequestModel.attributeTypeMap;
    }
}
